
import { AppBar, Button, InputBase, Menu, MenuItem, styled, Toolbar, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import 'moment/locale/pt-br';
import { useContext, useState } from 'react';
import { useRedirect } from 'react-admin';

import { SidebarToggleButton } from 'react-admin';
import { AppContext } from '../../providers/app-context-provider/app.context';
import { NotificationsAppBar } from './notifications-app-bar.component';
import { useStyles } from './styles';
import { ProfileInfoComponent } from '../../components/profile-info';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    height: 48,
    backgroundColor: theme.palette.primary.dark
}))

export const JuristtaAppBar = (props) => {

    const classes = useStyles();
    const redirect = useRedirect();
    const appContext = useContext(AppContext)

    const [value, setValue] = useState('')
    const [filter, setFilter] = useState('name')
    const [anchorEl, setAnchorEl] = useState(null);

    const student = appContext?.profile?.name === 'Aluno'

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (value) => {
        setFilter(value)
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const translateFilter = (value) => {
        switch (value) {
            case 'name':
                return 'Nome';
            case 'cpf':
                return 'CPF/CNPJ'
            case 'phone':
                return 'Telefone'
            case 'service':
                return 'Protocolo'
            case 'process':
                return 'Processo'
            case 'email':
                return 'Email';
            default:
                break;
        }
    }

    const handleSubmit = () => { redirect(`/search?filter=${filter}&value=${value}`) }
    return (
        <AppBar color='secondary' {...props}>
            <StyledToolbar variant='dense' disableGutters>
                <SidebarToggleButton />
                <Typography variant="h6" id="react-admin-title" />
                <span className={classes.spacer} />
                {
                    appContext?.product?.id === 2 && !student && <>
                        <Button aria-controls="simple-menu" color='primary' aria-haspopup="true" onClick={handleMenuClick} className={classes.searchButton} variant='contained'>
                            {translateFilter(filter)}
                            <ExpandMore />
                        </Button>
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            <MenuItem key='search-menu-item-1' onClick={() => handleMenuClose('name')}>Nome </MenuItem>
                            <MenuItem key='search-menu-item-2' onClick={() => handleMenuClose('cpf')}>CPF/CNPJ</MenuItem>
                            <MenuItem key='search-menu-item-3' onClick={() => handleMenuClose('phone')}>Telefone</MenuItem>
                            <MenuItem key='search-menu-item-4' onClick={() => handleMenuClose('service')}>Protocolo</MenuItem>
                            <MenuItem key='search-menu-item-5' onClick={() => handleMenuClose('process')}>Processo</MenuItem>
                            <MenuItem key='search-menu-item-6' onClick={() => handleMenuClose('email')}>Email</MenuItem>
                        </Menu>

                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <InputBase
                                onChange={handleChange}
                                placeholder="Busca de atendimentos"
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                value={value}
                                inputProps={{ 'aria-label': 'search' }}
                            />
                        </div>
                        <Button style={{ marginLeft: '8px' }} color='inherit' className={classes.searchButton} onClick={handleSubmit} variant='contained' disabled={value.length === 0}> Buscar </Button>
                    </>
                }
                <NotificationsAppBar />
                <ProfileInfoComponent />
            </StyledToolbar>
        </AppBar>
    )
}